import React from 'react';

export default props => (
  <svg {...props} viewBox="0 0 150 150">
    {props.children}
    <path fill="none" stroke="#000" strokeLinejoin="round" strokeWidth={0.5} d="M34.5 109.3 60.7 94V67L34.5 82.3v27Z" />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m6.5 103.9 68.3-39.4 68.6 39.5L75 143.4 6.5 103.9Z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeDasharray="0 0 6.77 6.77"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m6.8 110.1 68-39.3 68.7 39.6-68.2 39.2-68.5-39.5Z"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeDasharray="0 0 6.77 6.77"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m47.7 117.8 53.2-30.6.2-86.8-53.4 31v86.4Z"
    />
    <path d="M75.2 65.8v-2.6a13.2 13.2 0 0 1 1.6-6.4 39 39 0 0 1 2.5-4 44 44 0 0 0 2.5-4c.6-1.1 1-2.1 1.2-3 .3-1 .4-1.8.4-2.7 0-1.5-.3-2.7-.9-3.5a3 3 0 0 0-2.5-1.2c-1 0-2.2.4-3.5 1.2a14 14 0 0 0-3.7 3.5c-1.1 1.4-2 3-2.6 4.7-.6 1.7-1 3.3-1 5l-1 .6a20.7 20.7 0 0 1 4-11 16 16 0 0 1 4.3-4c1.5-.9 2.8-1.3 4-1.3 1.2 0 2.1.5 2.8 1.4.7.9 1.1 2.2 1.1 4 0 1-.1 2-.4 3a48.8 48.8 0 0 1-4 7.8l-2.4 3.8a11 11 0 0 0-1.4 5.6v2.5l-1 .6Zm.5 10.9c-.3.1-.6.2-.8 0-.2 0-.3-.3-.3-.7s0-.7.3-1c.2-.5.5-.8.8-1 .3-.1.5-.2.8 0 .2 0 .3.3.3.7 0 .2 0 .5-.2.7a2.5 2.5 0 0 1-1 1.3Z" />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m113.5 102.8-15.2 8.6 7.7 4.4 15.3-8.6-7.8-4.4Z"
    />
    <path
      fill="#F4EEE6"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m93.4 26.9 20.3-11.7V8.7L93.4 20.5V27Z"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M26.3 62 58 43.9l.1-29.2-31.8 18.5v29Z"
    />
    <path fill="#F4EEE6" stroke="#000" strokeLinejoin="round" strokeWidth={0.5} d="m26.3 62-2.8-1.7V31.4l2.8 1.7v29Z" />
    <path
      fill="#fff"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m26.3 33.1-2.7-1.7 31.8-18.6 2.7 1.8-31.8 18.5Z"
    />
    <path fill="#F4EEE6" d="M53.5 40.3 32.2 52.5v-16l21.2-12.3v16.1Z" />
    <path
      fill="#fcf9f4"
      d="M37 39.6c1-.9 2-.6 2.2.6.3 1.1-.2 2.7-1.1 3.6-.9.8-1.9.5-2.1-.6-.3-1.2.2-2.8 1-3.7Zm5.5-3.3c1-.8 1.9-.6 2.1.6.3 1.2-.2 2.8-1 3.6-1 .9-2 .6-2.2-.6-.3-1.1.2-2.7 1.1-3.6Zm5.5-3.1c.8-.8 1.8-.5 2 .6.4 1.2-.1 2.8-1 3.7s-1.9.5-2.2-.6c-.3-1.2.2-2.8 1.1-3.7Z"
    />
    <path
      fill="#F4EEE6"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M93.5 55.3c-4.5 8-7 16.2-7.3 22.9-.3 6.7 1.4 12 5.5 14.3 3.7 2.1 7 2.9 9.8 2.5s5.5-1.7 7.9-3.8c4.5-4.1 8.3-11 12.6-18.5l.6-1 1.3-2.4 4.9-8.9c1.7-3.5 3.1-6.9 3.8-10 .6-3 .5-6-.8-8.7-1.2-2.6-3.6-5-7.4-7.2-4.1-2.3-9.6-1-15.1 2.8a54 54 0 0 0-15.8 18Z"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M96.8 57.2c-4.5 8-7 16-7.4 22.8-.3 6.7 1.4 12 5.5 14.3 4 2.3 9.6 1 15.1-2.7a54.2 54.2 0 0 0 15.8-18c4.4-8 7-16.2 7.3-23 .3-6.6-1.4-12-5.5-14.3-4-2.3-9.6-1-15.1 2.8a54 54 0 0 0-15.8 18Z"
    />
    <path
      fill="#F4EEE6"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M100 59a47.2 47.2 0 0 0-6.3 18.6c-.4 5.4.8 9.7 4 11.5 3.2 1.8 7.5.6 12-2.6 4.3-3.1 9-8.4 12.6-15a47.2 47.2 0 0 0 6.3-18.6c.4-5.4-.9-9.7-4-11.5-3.2-1.8-7.5-.6-12 2.6-4.4 3.2-9 8.4-12.6 15Z"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M100.1 58.7a48.7 48.7 0 0 0-6.3 19c-.2 2.6-.1 5 .3 6.7.4 1.7 1.1 3 2.2 3.6 3.1 1.8 7.4.8 11.8-2.3 4.4-3 8.9-8.2 12.6-14.8a48.3 48.3 0 0 0 6.3-18.5c.5-5.4-.7-9.7-3.9-11.5-1.3-.8-3-.8-4.9-.2a20 20 0 0 0-6 3.4A50.3 50.3 0 0 0 100 58.7Z"
    />
    <path
      fill="#edf4f7"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M100.1 58.7a48.7 48.7 0 0 0-6.3 19c-.2 2.6-.1 5 .3 6.7.4 1.7 1.1 3 2.2 3.6 3.1 1.8 7.4.8 11.8-2.3 4.4-3 8.9-8.2 12.6-14.8a48.3 48.3 0 0 0 6.3-18.5c.5-5.4-.7-9.7-3.9-11.5-1.3-.8-3-.8-4.9-.2a20 20 0 0 0-6 3.4A50.3 50.3 0 0 0 100 58.7Z"
    />
    <path
      fill="#F4EEE6"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m65.5 121.2 22.3-30.5c.4-.7 1.2-1 2-1 1 0 2 .3 3 1a6 6 0 0 1 2 2.3c.4.9.5 1.8 0 2.6v.2l-21.4 30.5-.1.2-.2-.1-7.5-4.8-.3-.2.2-.2Z"
    />
    <path
      fill="#F4EEE6"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M70.8 121.3c1 .7 1.9 1.6 2.3 2.6.5 1 .6 2 .2 2.8-.4.8-1.3 1.1-2.3 1.1a6 6 0 0 1-3.1-1.1c-1.1-.7-2-1.7-2.4-2.6-.5-1-.6-2-.1-2.8s1.2-1.1 2.2-1.1c1 0 2.1.3 3.2 1Z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeDasharray="0 0 6.77 6.77"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m96.7 88.7 13.2-7.5v-35"
    />
  </svg>
);
